// @flow

import {
  PACKAGE_SEARCH_REQUEST,
  PACKAGE_SEARCH_REQUESTED,
  PACKAGE_SEARCH_REQUESTED_ERROR,
  PACKAGE_SEARCH_RESET,
  PACKAGE_SEARCHBAR_REQUEST,
  PACKAGE_SEARCHBAR_REQUESTED
} from './constants';

import type { Action, State } from '../types';

const initialState: State = {
  data: [],
  numberOfPages: 0,
  getStatus: {
    requesting: false,
    error: null
  }
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case PACKAGE_SEARCH_REQUEST: {
      return {
        ...state,
        data: [],
        getStatus: {
          requesting: true,
          error: null
        }
      };
    }
    case PACKAGE_SEARCH_REQUESTED: {
      return {
        ...state,
        data: action.data,
        getStatus: {
          requesting: false,
          error: null
        },
        numberOfPages: parseInt(action?.headers?.total_pages, 10) || state?.numberOfPages,
      };
    }
    case PACKAGE_SEARCH_RESET:
      return initialState;
    case PACKAGE_SEARCH_REQUESTED_ERROR: {
      return {
        ...state,
        getStatus: {
          requesting: false,
          error: action.error
        }
      };
    }
    case PACKAGE_SEARCHBAR_REQUEST: {
      return {
        ...state,
        searchData: action.data || [],
        getStatus: {
          requesting: true,
          error: null
        }
      };
    }
    case PACKAGE_SEARCHBAR_REQUESTED: {
      return {
        ...state,
        searchData: action.data || [],
        getStatus: {
          requesting: false,
          error: null
        },
        numberOfPages: state.numberOfPages || parseInt(action.headers?.total_pages, 10)
      };
    }
    default:
      return state;
  }
};
